import React from 'react';
import { Award, Users, Music2, Home } from 'lucide-react';
import { aboutData } from '../mockData';
import { Card } from './ui/card';

const About = () => {
  const stats = [
    { icon: Music2, label: 'Specialty', value: aboutData.specialization },
    { icon: Users, label: 'Students', value: aboutData.students },
    { icon: Award, label: 'Instructor', value: aboutData.experience }
  ];

  return (
    <section id="about" className="py-24">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left side - Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              {aboutData.title}
            </h2>
            <p className="text-lg text-slate-200 leading-relaxed mb-8">
              {aboutData.bio}
            </p>
            
            <div className="space-y-4 mb-8">
              {stats.map((stat, index) => {
                const Icon = stat.icon;
                return (
                  <div 
                    key={index}
                    className="flex items-center gap-4 p-4 bg-white/5 backdrop-blur-sm border border-purple-500/20 rounded-lg transition-all hover:border-purple-400/40 hover:bg-white/10"
                  >
                    <div className="p-3 bg-purple-500/20 rounded-lg">
                      <Icon className="w-6 h-6 text-purple-300" />
                    </div>
                    <div>
                      <p className="text-sm text-slate-400">{stat.label}</p>
                      <p className="text-lg font-semibold text-white">{stat.value}</p>
                    </div>
                  </div>
                );
              })}
            </div>
            
            {/* Studio Info */}
            <div className="p-4 bg-purple-500/15 backdrop-blur-sm border border-purple-400/25 rounded-lg">
              <div className="flex items-start gap-3">
                <Home className="w-5 h-5 text-purple-300 flex-shrink-0 mt-0.5" />
                <p className="text-sm text-slate-200">
                  {aboutData.studioInfo}
                </p>
              </div>
            </div>
          </div>
          
          {/* Right side - Instructor Photo */}
          <div className="relative">
            <div className="relative rounded-lg overflow-hidden shadow-2xl">
              <img 
                src="/images/instructor-new.jpg" 
                alt="Felix Munger - Music Instructor" 
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/30 to-transparent"></div>
            </div>
            {/* Decorative element */}
            <div className="absolute -z-10 top-8 left-8 w-full h-full border-2 border-purple-500/20 rounded-lg"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;